<template>
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.7395 15.0638L10.729 15.0304L17.3856 8.93637V6H6.70612V8.93637H13.085L13.0955 8.96442L6.50391 15.0638V18H17.4929V15.0638H10.7395Z" fill="currentColor" />
  </svg>
</template>
